module.exports = __webpack_public_path__ + "static/media/skopei-s.96b2b710.svg";